<template>
  <div class="goodsTable">
    <vxe-toolbar v-if="$route.query.isEdit == 'Y'">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('acceptanceDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('acceptanceDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :columns="columnList"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      auto-resize
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <collectionInfo ref="collectionInfo" :detail="detail"> </collectionInfo>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import collectionInfo from './collectionInfo';

  export default {
    name: 'returnAdd',
    components: {
      collectionInfo,
      // SearchTable,
      // InputNumber,
    },
    props: ['type', 'baseData'],
    data() {
      return {
        returnStatus: '',
        acceptanceInfo: {},
        goodsData: [],
        editConfig: {
          trigger: 'click',
          mode: 'row',
          showStatus: true,
          activeMethod: this.activeRowMethod,
        },
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
        delLockExChangeList: [],
        detail: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          // {title: this.$t('tFundCreditLetterLockExchangeRate.column.acceptanceId'), field: "acceptanceId", width: 120},//承兑行项目id
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.lockAmount'),
            field: 'lockAmount',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.lockAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['lockAmount']}
                    placeholder={this.$t(
                      'tFundCreditLetterLockExchangeRate.placeholder.lockAmount'
                    )}
                    clearable={true}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'lockAmount')}
                  ></input-number>,
                ];
              },
            },
          }, //锁汇金额
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.externalLockExchangeRate'),
            field: 'externalLockExchangeRate',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.externalLockExchangeRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['externalLockExchangeRate']}
                    placeholder={this.$t(
                      'tFundCreditLetterAcceptance.placeholder.externalLockExchangeRate'
                    )}
                    clearable={true}
                    precision={this.$globalVar.ePoint}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'externalLockExchangeRate')}
                  ></input-number>,
                ];
              },
            },
          }, //外部锁汇价
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.internalLockExchangeRate'),
            field: 'internalLockExchangeRate',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.internalLockExchangeRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['internalLockExchangeRate']}
                    placeholder={this.$t(
                      'tFundCreditLetterAcceptance.placeholder.internalLockExchangeRate'
                    )}
                    clearable={true}
                    precision={this.$globalVar.ePoint}
                    max={999999999999.99999}
                    onInput={(val) => this.updateCol(row, val, 'internalLockExchangeRate')}
                  ></input-number>,
                ];
              },
            },
          }, //内部锁汇价
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.bankAccountNum'),
            field: 'bankAccountNum',
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankAccountNum}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccount"
                    isMultiple={true}
                    currentValue={row['bankAccountNum']}
                    checkRowKeys={[row['bankAccountNum']]}
                    extraData={{ companyCode: this.baseData.businessCompanyCode }}
                    onInput={(val) => this.updateCol(row, val, 'bankAccountNum')}
                  ></search-table>,
                ];
              },
            },
          }, //锁汇银行账户号码
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.bankAccountName'),
            field: 'bankAccountName',
            width: 200,
          }, //锁汇银行账户名
          {
            title: this.$t('tFundCreditLetterLockExchangeRate.column.lockDueDate'),
            field: 'lockDueDate',
            width: 200,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'date',
                format: 'yyyy/MM/dd',
                valueFormat: 'yyyy-MM-dd',
              },
            },
          }, //锁汇到期日
        ];
      },
      goodsTableEditRules() {
        return {
          lockAmount: [
            {
              required: true,
              message: this.$t('acceptanceDetail.lockExchangeRateTable.lockAmount'),
            },
          ],
          externalLockExchangeRate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.lockExchangeRateTable.externalLockExchangeRate'),
            },
          ],
          internalLockExchangeRate: [
            {
              required: true,
              message: this.$t('acceptanceDetail.lockExchangeRateTable.internalLockExchangeRate'),
            },
          ],
          bankAccountName: [
            {
              required: true,
              message: this.$t('acceptanceDetail.lockExchangeRateTable.branchName'),
            },
          ],
          bankAccountNum: [
            {
              required: true,
              message: this.$t('acceptanceDetail.lockExchangeRateTable.bankAccountNum'),
            },
          ],
        };
      },
    },
    mounted() {},
    methods: {
      //JSX更新字段
      updateCol(row, val, type) {
        row[type] = val;
        if (type == 'bankAccountNum') {
          row.bankAccountNum = val[0].bankAccountNum;
          row.bankAccountName = val[0].bankAccountName;
          row.branchCode = val[0].branchCode;
          row.branchName = val[0].branchName;
        } else if (type == 'lockAmount') {
          this.$refs.goodsTable.updateFooter();
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['lockAmount'].includes(column.property)) {
              return data
                .map((i) => i['lockAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
            }
            return null;
          }),
        ];
      },
      getDetail(allDetail) {
        if (allDetail != null && allDetail.length > 0) {
          this.goodsData = allDetail;
        }
      },
      // 载具表格新增一行
      insertEvent() {
        this.$refs.goodsTable.validate().then(() => {
          const record = {
            tempAcceptanceId: this.acceptanceInfo.tempId,
            acceptanceId: this.acceptanceInfo.id,
            lockAmount: 0,
            externalLockExchangeRate: 0,
            internalLockExchangeRate: 0,
            branchName: null,
            bankAccountNum: null,
          };
          this.goodsData.push(record);
          this.$refs.goodsTable
            .insertAt(record, -1)
            .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('acceptanceDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) this.delLockExChangeList.push(item.id);
            });
            this.$refs[goodsTable].removeSelecteds();
            this.goodsData = this.$refs[goodsTable].getTableData().fullData;
            console.log(this.goodsData);
            this.$refs[goodsTable].updateFooter();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          const tableForm = {};
          let lockExchangeRateList = [];
          if (this.$refs.goodsTable.getTableData().fullData.length) {
            this.$refs.goodsTable.getTableData().fullData.map((item) => {
              lockExchangeRateList.push({
                tenantCode: this.userInfo.tenantCode,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                clCode: this.baseData.clCode,
                ...item,
              });
            });
          }
          tableForm.creditLetterDelayLockList = lockExchangeRateList;
          tableForm.delDelayLockList = this.delLockExChangeList;
          // 点击提交，走校验
          // if (tableForm.lockExchangeRateList.length == 0) {
          //   this.$message({
          //     showClose: true,
          //     message: this.$t('acceptanceDetail.msg.lockGoodsMsg'),
          //     type: 'error',
          //   });
          //   return false;
          // } else {
          this.$refs['goodsTable']
            .validate()
            .then((valid) => {
              console.log('111111', valid);
              resolve(tableForm);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.$t('acceptanceDetail.msg.lockGoodsMsg'),
                type: 'error',
              });
              reject();
            });
          // }
        });
      },

      activeRowMethod() {
        //禁用编辑
        return this.$route.query.isEdit == 'Y';
      },
    },
  };
</script>
<style scoped>
  .acceptBaseInfo {
    float: right;
  }
  .acceptBaseInfoItem {
    margin-right: 20px;
  }
</style>
